import React, { useEffect, useState, useRef} from 'react';
import { Link, useNavigate } from 'react-router-dom';
// Update import if necessary
import { getAllMessages, getCoachDetails, getProjectForPatient} from '../../api/Patient'; 
import LogoutIcon from '../Icons/LogoutIcon';
import Loader from '../Loader/Loader';
import ChatApp from './ChatApp/ChatApp';
import PatientActivity from './PatientActivity/PatientActivity';
import PatientList from './PatientList/PatientList';
import ProjectList from '../projectList/ProjectList'; // Ensure this path is correct
import './PrimaryPatient.css';
import { getPendingReviewCount } from '../../services/videos';

const PrimaryPatient = () => {
  const navigate = useNavigate();
  const [toggle, setToggle] = useState(false);
  const patientsRef = useRef([]);
  // Data States
  const [patients, setPatients] = useState(null);
  const [wellnessCoach, setWellnessCoach] = useState(null);
  const [projects, setProjects] = useState([]); 
  const [unreadProjectIds, setUnreadProjectIds] = useState([]);
  // Selection States
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [activeProject, setActiveProject] = useState(null); 

  const [videoReviewCount, setVideoReviewCount] = useState(0);
  const [isVideoCountLoading, setIsVideoCountLoading] = useState(false);

  // --- EFFECT 1: INITIALIZATION ---
  // Fetches Coach Details and sets the initial Active Project
  useEffect(() => {
    getCoachDetails()
      .then((res) => {
        setWellnessCoach(res);
        if (res.Projects && res.Projects.length > 0) {
          setProjects(res.Projects);
          // Setting this will trigger EFFECT 2 automatically
          setActiveProject(res.Projects[0]);
          sessionStorage.setItem("selectedProjectId", res.Projects[0]?.Id);
        } else {
            // If no projects, try fetching messages without ID (fallback)
            fetchMessages(null);
        }
      })
      .catch((e) => console.log(e));
  }, []);
  useEffect(() => {
    patientsRef.current = patients;
  }, [patients]);

  // --- EFFECT 2: FETCH MESSAGES ON PROJECT CHANGE ---
  // Runs whenever 'activeProject' changes
  useEffect(() => {
    if (activeProject) {
      fetchMessages(activeProject.Id);
    }
  }, [activeProject]);

  // --- EFFECT 3: FETCH VIDEO COUNT ON PROJECT CHANGE ---
  useEffect(() => {
    if (!activeProject?.Id) {
      setVideoReviewCount(0);
      return;
    }

    getPendingReviewCount(activeProject.Id)
      .then((count) => {
        setVideoReviewCount(count);
      })
      .catch((error) => {
        console.error(
          "Failed to load video review count:",
          error
        );
        setVideoReviewCount(0);
      });
  }, [activeProject?.Id]);

  // Helper function to call API and set state
  const fetchMessages = (projectId) => {
    // Set to null to SHOW the loader while fetching
    setPatients(null); 
    
    getAllMessages(projectId)
      .then((res) => {
        console.log("Fetched messages for Project:", projectId, res.data);
        
        // FIX: If res.data is undefined/null, default to empty array []
        // This stops the spinner because [] is truthy
        setPatients(res.data || []);
      })
      .catch((err) => {
        console.log(err);
        // FIX: Even if there is an error, stop the spinner
        setPatients([]); 
      });
  };

  const selectPatient = (patient) => {
    setSelectedPatient(patient);
  };

  const selectProject = (project) => {
    setActiveProject(project);
    sessionStorage.setItem("selectedProjectId", project.Id);
    setSelectedPatient(null);
    // Optional: Remove the red dot when we open the project
    setUnreadProjectIds(prev => prev.filter(id => id !== project.Id));
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/signin');
  };

  const getPatientById = (Id) => {
    return patients?.find((x) => (x.Id === Id));
  };

  const handleMessageUpdate = async (obj, patient, createdBy, recievedMessage) => {
    // 1. Identify the Sender
    // If the creator is not the coach, we try to find them in the current patient list
    const currentPatientsList = patientsRef.current || [];
    let sender;
    if (createdBy !== wellnessCoach.Id) {
      sender = currentPatientsList.find((x) => x.Id === createdBy);
      //sender = getPatientById(createdBy);
      console.log("line 100", sender);
      console.log("line 101", currentPatientsList);
    } else {
      sender = patient; // It's the coach sending a message
    }

    // --- LOGIC FOR UNREAD DOTS (PROJECT INDICATORS) ---
    // We only care about unread dots if the message is FROM a patient
    if (createdBy !== wellnessCoach.Id) {
      
      let targetProjectId = null;


      // Scenario A: The patient is in the CURRENTLY active project
      // We know this because 'sender' was found in the 'patients' list
      if (sender) {
        targetProjectId = activeProject?.Id;
      } 
      // Scenario B: The patient is NOT in the current list
      // This means the message is coming from a different Project
      else {
        try {
          // Call the API helper we created to find which project this user belongs to
          const mapping = await getProjectForPatient(createdBy);
          console.log(mapping)
          if (mapping && mapping.ProjectId) {
            targetProjectId = mapping.ProjectId;
            // If we identified a project ID, mark it as having unread messages
            if (targetProjectId && !sender) {
              setUnreadProjectIds((prev) => {
                // Prevent duplicates in the array
                if (!prev.includes(targetProjectId)) {
                  return [...prev, targetProjectId];
                }
                return prev;
              });
              // If 'sender' is undefined, it means this patient belongs to a different project
              // so we simply skip updating the current message list.
              if (!sender) return;
            }
          }
        } catch (error) {
          console.error("Could not determine project for incoming message", error);
        }
      }

      
    }
    // --------------------------------------------------

    // 2. Update Chat UI (Only if the patient is visible in the current list)
    

    // Standard logic to append the new message to the existing list
    let sortedMessages = sender?.messages 
      ? sender.messages.sort((a, b) => a.Id - b.Id) 
      : [];
    
    const length = sortedMessages?.length;
    const lastMessage = length > 0 ? sortedMessages[length - 1] : null;

    const newMessage = {
      ActivityId: null,
      Body: obj?.Body,
      CreatedBy: createdBy,
      DateCreated: obj?.DateCreated,
      DateDestroyed: null,
      DateModified: obj?.DateCreated,
      DestinationId: obj?.Id,
      HasRead: false,
      Id: lastMessage ? `${parseInt(lastMessage?.Id, 10) + 1}` : '1',
      PrimaryWellnessCoachUserId: lastMessage?.PrimaryWellnessCoachUserId,
      SecondaryWellnessCoachUserId: lastMessage?.SecondaryWellnessCoachUserId,
      UserActivityId: obj?.Body ? null : obj?.UserActivityId,
      UserActivityMapping: obj?.Body ? null : obj?.UserActivityMapping,
    };

    sortedMessages.push(newMessage);

    // 3. Update the main patients state
    let newPatients = [];
    patients.map((x) => {
      x.Id === sender.Id
        ? newPatients.push({ ...x, messages: sortedMessages })
        : newPatients.push(x);
    });
    
    setPatients([...newPatients]);
  };

  // Render Logic
  if (wellnessCoach != null) {
    return (
      <div className='container-fluid'>
        
        {/* HEADER */}
        <div className='row mt-2'>
          <div className='center-logo col-2 border-end border-bottom'>
            <img
              className='logo'
              src='/assets/Logos/AppIcon.png'
              alt="App Logo"
              style={{
                marginBottom: '7%',
                height: '3rem',
                width: 'auto',
                maxWidth: '100%',
                display: 'block',
                margin: '0 auto'
              }}
            />
            <div align='center' onClick={handleLogout} className='logout-icon' style={{marginTop: '10px', cursor:'pointer'}}>
              <LogoutIcon />
            </div>
          </div>

          <div className='col border-bottom'>
            <div className='row center-align' style={{ marginTop: '2%' }}>
              <h5>
                Welcome, {wellnessCoach.LastName} {wellnessCoach.FirstName}
              </h5>
            </div>
          </div>

          {selectedPatient != null && (
            <div className='col-3 border-start border-bottom'>
              <div className='row center-align '>
                <h4>
                  {selectedPatient.FirstName} {selectedPatient.LastName}
                </h4>
              </div>
              <div className='row mt-2 ms-1'>
                <div className='col panelTitle' style={{ padding: '0' }}>
                  <h5
                    className={toggle ? 'secondary' : ''}
                    onClick={() => setToggle(!toggle)}
                    style={{cursor:'pointer'}}
                  >
                    Patient Activity
                  </h5>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* BODY */}
        <div className='row' style={{ height: '85vh' }}>
          
          {/* 1. PROJECT LIST */}
          <div className='col-2 border-end sidePanel' style={{ overflowY: 'auto' }}>
            <div className='row panelTitle p-2'>
              <h4>Projects</h4>
            </div>
            
            <ProjectList 
              projects={projects} 
              selectProject={selectProject} 
              activeProject={activeProject}
              unreadProjectIds={unreadProjectIds}
            />
          </div>

          {/* 2. PATIENT LIST */}
          <div className='col-2 border-end sidePanel'>
            <div className='row panelTitle p-2'>
              <h4>Messages</h4>
            </div>
            <div className='row'>
              {/* Show loader or list */}
              {patients ? (
                 <PatientList patients={patients} selectPatient={selectPatient} />
              ) : (
                 <div className="text-center mt-5"><Loader /></div>
              )}
            </div>
            {/* Video Review Count */}
            <Link to={videoReviewCount > 0 ? "/videos" : "#"}
              className={`video-review-link ${videoReviewCount === 0 ? "disabled" : ""}`}
              onClick={(e) => {
                if (videoReviewCount === 0) {
                  e.preventDefault();
                }
              }}
            >
            <div className="content">
              <span className="title">Video Review</span>
              <span className="badge">{videoReviewCount}</span>
            </div>
            <div className="arrow">{">"}</div>
          </Link>
          </div>

          {/* 3. CHAT AREA */}
          {selectedPatient != null ? (
            <>
              <div className='col-5 chat-area'>
                <ChatApp
                  patient={selectedPatient}
                  updatePatient={handleMessageUpdate}
                  wellnessCoach={wellnessCoach}
                  activeProject={activeProject}
                />
              </div>
              <div className='col-3 border-start sidePanel'>
                 <PatientActivity patient={selectedPatient} activeProject={activeProject} />
              </div>
            </>
          ) : (
            <div className='col-8 row'>
              <div className='col'>
                <div style={{ marginTop: '30vh', textAlign: 'center' }}>
                  <h1>Start a conversation</h1>
                  <p className="text-muted">
                    Select a project and then a patient to chat with
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <Loader />
      </div>
    );
  }
};

export default PrimaryPatient;